import { render, staticRenderFns } from "./Uploadedvideo.vue?vue&type=template&id=3eff8596&scoped=true&"
import script from "./Uploadedvideo.vue?vue&type=script&lang=js&"
export * from "./Uploadedvideo.vue?vue&type=script&lang=js&"
import style0 from "./Uploadedvideo.vue?vue&type=style&index=0&id=3eff8596&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eff8596",
  null
  
)

export default component.exports